import { GasStationResponseApi } from "./GasStationResponseApi";
import { PriceCorrectionRequestApi } from "./PriceCorrectionRequestApi";
import { GasStationCorrectionRequestApi } from "./GasStationCorrectionRequestApi";
import { GasStationModel } from "./GasStationModel";
import { AdresseModel } from "../../../../../shared/models/view/Adresse";
import { FeedbackFormModel } from "./FeedbackFormModel";
import { CoordinatesModel } from "../../../../../shared/models/view/Coordinates";
import { CorrectionRequestApi } from "./CorrectionRequestApi";

export class ModelAdapter {

	public static getGasStationModel(gasStationResponse: GasStationResponseApi): GasStationModel {
		const result = new GasStationModel();
		if (gasStationResponse && gasStationResponse.Tankstelle) {
			const station = gasStationResponse.Tankstelle;
			result.ID = String(station.PoiId);
			result.Marke = station.Marke;
			result.Name = station.Name;
			result.Adresse = new AdresseModel();
			result.Adresse.StrasseHausnummer = station.Strasse;
			result.Adresse.Postleitzahl = station.Plz;
			result.Adresse.Ort = station.Ort;
			result.GeoPosition = new CoordinatesModel({
				Latitude: station.Latitude,
				Longitude: station.Longitude,
				X: station.x,
				Y: station.y
			});
		}
		return result;
	}

	public static getPriceCorrectionRequestApi(formModel: FeedbackFormModel): PriceCorrectionRequestApi {
		const result = new PriceCorrectionRequestApi();
		ModelAdapter.setCorrectionRequestProperties(formModel, result);
		if (formModel.PriceCorrection) {
			result.PreisSuperE10 = formModel.PriceCorrection.PreisSuperE10;
			result.PreisSuper = formModel.PriceCorrection.PreisSuper;
			result.PreisDiesel = formModel.PriceCorrection.PreisDiesel;
		}
		return result;
	}

	public static getGasStationCorrectionRequestApi(formModel: FeedbackFormModel): GasStationCorrectionRequestApi {
		const result = new GasStationCorrectionRequestApi();
		ModelAdapter.setCorrectionRequestProperties(formModel, result);
		if (formModel.GasStationCorrection) {
			result.TankstelleName = formModel.GasStationCorrection.Name;
			result.TankstelleBetreiber = formModel.GasStationCorrection.Marke;
			if (formModel.GasStationCorrection.Adresse) {
				result.TankstelleStrasseHausnummer = formModel.GasStationCorrection.Adresse.StrasseHausnummer;
				result.TankstellePostleitzahl = formModel.GasStationCorrection.Adresse.Postleitzahl;
				result.TankstelleOrt = formModel.GasStationCorrection.Adresse.Ort;
			}
			if (formModel.GasStationCorrection.OeffnungsZeiten) {
				result.TankstelleGeoeffnetAm = formModel.GasStationCorrection.OeffnungsZeiten.Wochentag;
				result.TankstelleGeoeffnetVon = formModel.GasStationCorrection.OeffnungsZeiten.Von;
				result.TankstelleGeoeffnetBis = formModel.GasStationCorrection.OeffnungsZeiten.Bis;
			}
			if (formModel.GasStationCorrection.GeoPosition) {
				result.TankstelleLatitude = formModel.GasStationCorrection.GeoPosition.Latitude;
				result.TankstelleLongitude = formModel.GasStationCorrection.GeoPosition.Longitude;
			}
		}
		return result;
	}

	private static setCorrectionRequestProperties(formModel: FeedbackFormModel, correctionRequest: CorrectionRequestApi): void {
		correctionRequest.EntdecktAm = formModel.EntdecktAm;
		correctionRequest.EntdecktUm = formModel.EntdecktUm;
		if (formModel.GasStation) {
			correctionRequest.TankstelleID = formModel.GasStation.ID;
		}
	}
}